module.exports = __webpack_public_path__ + "static/media/center.a2defb21.png";